import { render, staticRenderFns } from "./TestTry.vue?vue&type=template&id=0d1c0f9c&"
import script from "./TestTry.vue?vue&type=script&lang=js&"
export * from "./TestTry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports